export const isDevHostname = (hostname = '') =>
  hostname.endsWith('.sleepiodev.com') ||
  hostname.endsWith('.trydaylightdev.com') ||
  hostname.endsWith('.sleepioqa.com') ||
  hostname.endsWith('.trydaylightqa.com') ||
  hostname.endsWith('.qa.sleepio.com') ||
  hostname.endsWith('.qa.trydaylightdev.com');
